import { logEvent } from 'firebase/analytics';
import { analytics } from './index';

const eventTypes = {
  CREATE_ORDER_FROM_INITIAL_SCREEN: 'create_order_from_initial_screen',
  CREATE_ORDER_FROM_ASSETS_HOME_SCREEN: 'create_order_from_assets_home_screen',
  CREATE_ORDER_FROM_ORDER_SCREEN: 'create_order_from_order_screen',
  CREATE_ORDER_FROM_AVAILABILITY_SCREEN:
    'create_order_from_availability_screen',
  CANCEL_ORDER_CREATION: 'cancel_order_creation',
  CHANGE_LANGUAGE_TO_ENGLISH: 'change_language_to_english',
  CHANGE_LANGUAGE_TO_PORTUGUESE: 'change_language_to_portuguese',
  LOGOUT: 'logout',
} as const;

const faLogEvent = (event: keyof typeof eventTypes, params?: any): any => {
  return logEvent(analytics, eventTypes[event], params);
};

export { faLogEvent };
